import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { Button } from "./ui/button";

export const LanguageToggle = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === "ar" ? "en" : "ar");
  };

  return (
    <Button 
      variant="ghost" 
      onClick={toggleLanguage}
      className="rounded-full hover:bg-primary/10 transition-colors text-primary font-bold px-4 flex items-center gap-2"
    >
      <Globe className="h-[1.2rem] w-[1.2rem]" />
      <span>{i18n.language === "ar" ? "EN" : "عربي"}</span>
    </Button>
  );
};
